import styles from "./styles.module.scss";
import classnames from "utilities/classnames";

type ButtonIconProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  primary?: boolean;
  children?: React.ReactNode;
};

export const ButtonIcon = (props: ButtonIconProps) => {
  const { children, className, primary, ...rest } = props;

  const classes = classnames(styles.root, className, {
    [styles.primary]: primary,
  });

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
};
